import { Grid, FormLabel, FormHelperText, CircularProgress, Tooltip, IconButton } from '@material-ui/core';
import {
    SecondaryButton,
    TextBox,
    YesNoButton,
    SingelSelect,
    SelectBox,
    SecondaryCheckbox,
    PrimaryButton,
    MultiselectWithoutCheckbox,
    MultipleSelectWithMoreOp
} from '../../../Core/FormInput';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import React, { useState, useEffect, useContext, useCallback, useMemo } from 'react';
import DialogComp from '../../../Core/Modal/dialogModal';
import {
    getTcardCustomerNotesScreenDropdown,
    getTcardCustomerNotesGetDetails,
    postTcardAddUpdateCustomerNotes,
    getTCardCustomersGetExcelFile,
    uploadUploadCustomerDetails
} from '../../../Core/Service/T-card-services';
import AppContext from '../../../App/AppContext';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import EditIcon from '@material-ui/icons/Edit';
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';
import CustomeEditor from '../../../Core/CkEditor';
import AddEditCustomerNote from './addEditCustomerNote';
import AddBoxIcon from '@material-ui/icons/AddBox';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import { Backup } from '@material-ui/icons';

const StyledSubTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: 'white',
        borderBottom: '1px solid rgba(0,0,0,0.3)',
        padding: 5,
        fontSize: 11,
        fontWeight: 600
    },
    body: {
        fontSize: 14,
        backgroundColor: 'white',
        borderBottom: '1px solid rgba(0,0,0,0.3)',
        padding: 5
    }
}))(TableCell);
const StyledTableRow = withStyles((theme) => ({
    root: {}
}))(TableRow);

const CustomerNotesModal = ({ selectedCustomerID, selectedCustomer, onClose }) => {
    const { showToast } = useContext(AppContext);
    const [state, setState] = useState({
        tCardCustomerID: selectedCustomerID,
        tCardCustomerNoteID: '',
        orderNumberRequired: false,
        tCardCustomerNotes: '',
        tCardCustomerNoteTypeID: '',
        tCardCustomerNoteWorkflowID: '',
        tCardCustomerNoteDescription: '',
        dateCreated: '',
        tCardCustomerNoteDisplayPopInInternal: false,
        tCardCustomerNoteDisplayPopInTechnician: false,
        tCardCustomerStartupOrderPhone: '',
        tCardCustomerStartupOrderEmail: '',
        tCardCustomerSpendLimit: '',
        tCardCustomerAuthorityContactPhone: '',
        tCardCustomerAuthorityContactEmail: '',
        tCardCustomerTyreCompany: '',
        tCardCustomerTyreCompanyContactPhone: '',
        tCardCustomerCourtesyCarForInspection: false,
        tCardCustomerFinalOrderContactPhone: '',
        tCardCustomerFinalOrderContactEmail: '',
        tCardCustomerAuthorityProcess: '',
        tCardCustomerRetailDefectProcess: '',
        tCardCustomerOutOfTyreProcess: '',
        tCardCustomerBrakeTestPolicy: '',
        tCardCustomerPreferredPartsSupply: '',
        tCardCustomerFinalOrderNumberProcess: '',
        tCardCustomerOvernightVORUpdate: '',
        tCardCustomerPortalInfo: '',
        tCardCustomerAdditionalInfo: '',
        isDelete: false,
        errors: {},
        noteTypeList: [],
        workflowsList: [],
        workflowIDs: []
    });
    const [selectedIndex, setSelectedIndex] = useState(null);
    const [tCardCustomerDetails, setTCardCustomerDetails] = useState([]);
    const [tCardCustomerNotesList, setTCardCustomerNotesList] = useState([]);
    const [selectedData, setSelectedData] = useState({
        workflow: []
    });
    const editRowSelect = (index) => {
        setSelectedIndex(index);
        let tempListObj = [...tCardCustomerNotesList][index];

        const newNote = {
            tCardCustomerNoteID: tempListObj.tCardCustomerNoteID || '',
            tCardCustomerNoteTypeID: tempListObj.tCardCustomerNoteTypeID,
            tCardCustomerNoteDescription: tempListObj.tCardCustomerNoteDescription,
            tCardCustomerNoteDisplayPopInInternal: tempListObj.tCardCustomerNoteDisplayPopInInternal,
            tCardCustomerNoteDisplayPopInTechnician: tempListObj.tCardCustomerNoteDisplayPopInTechnician,
            workflowIDs: tempListObj.workflowIDs,
            workflow: tempListObj.workflow,
            isDelete: false,
            isUpdated: true,
            dateCreated: new Date()
        };

        setSelectedData((st) => ({
            ...st,
            workflow: tempListObj.workflow
        }));

        setState((prev) => ({
            ...prev,
            showModal: true,
            ...newNote
        }));
    };

    const fetchDropdownData = useCallback(async () => {
        const dropDownRes = await getTcardCustomerNotesScreenDropdown();
        if (dropDownRes.success) {
            setState((prev) => ({
                ...prev,
                noteTypeList: dropDownRes.data?.notesType || [],
                workflowsList: dropDownRes.data?.workflows || []
            }));
        }
    }, []);

    const fetchCustomerNotes = useCallback(async () => {
        if (state.tCardCustomerID && state.workflowsList.length) {
            const res = await getTcardCustomerNotesGetDetails(state.tCardCustomerID);
            if (res.success) {
                const data = res?.data || {};
                setState((prev) => ({
                    ...prev,
                    orderNumberRequired: data?.tCardCustomerDetails[0]?.orderNumberRequired || false,
                    tCardCustomerStartupOrderPhone: data?.tCardCustomerDetails[0]?.tCardCustomerStartupOrderPhone || '',
                    tCardCustomerStartupOrderEmail: data?.tCardCustomerDetails[0]?.tCardCustomerStartupOrderEmail || '',
                    tCardCustomerSpendLimit: data?.tCardCustomerDetails[0]?.tCardCustomerSpendLimit || '',
                    tCardCustomerAuthorityContactPhone: data?.tCardCustomerDetails[0]?.tCardCustomerAuthorityContactPhone || '',
                    tCardCustomerAuthorityContactEmail: data?.tCardCustomerDetails[0]?.tCardCustomerAuthorityContactEmail || '',
                    tCardCustomerTyreCompany: data?.tCardCustomerDetails[0]?.tCardCustomerTyreCompany || '',
                    tCardCustomerTyreCompanyContactPhone: data?.tCardCustomerDetails[0]?.tCardCustomerTyreCompanyContactPhone || '',
                    tCardCustomerCourtesyCarForInspection: data?.tCardCustomerDetails[0]?.tCardCustomerCourtesyCarForInspection || false,

                    tCardCustomerFinalOrderContactPhone: data?.tCardCustomerDetails[0]?.tCardCustomerFinalOrderContactPhone || '',
                    tCardCustomerFinalOrderContactEmail: data?.tCardCustomerDetails[0]?.tCardCustomerFinalOrderContactEmail || '',
                    tCardCustomerAuthorityProcess: data?.tCardCustomerDetails[0]?.tCardCustomerAuthorityProcess || '',
                    tCardCustomerRetailDefectProcess: data?.tCardCustomerDetails[0]?.tCardCustomerRetailDefectProcess || '',
                    tCardCustomerOutOfTyreProcess: data?.tCardCustomerDetails[0]?.tCardCustomerOutOfTyreProcess || '',
                    tCardCustomerBrakeTestPolicy: data?.tCardCustomerDetails[0]?.tCardCustomerBrakeTestPolicy || '',
                    tCardCustomerPreferredPartsSupply: data?.tCardCustomerDetails[0]?.tCardCustomerPreferredPartsSupply || '',
                    tCardCustomerFinalOrderNumberProcess: data?.tCardCustomerDetails[0]?.tCardCustomerFinalOrderNumberProcess || '',
                    tCardCustomerOvernightVORUpdate: data?.tCardCustomerDetails[0]?.tCardCustomerOvernightVORUpdate || '',
                    tCardCustomerPortalInfo: data?.tCardCustomerDetails[0]?.tCardCustomerPortalInfo || '',
                    tCardCustomerAdditionalInfo: data?.tCardCustomerDetails[0]?.tCardCustomerAdditionalInfo || ''
                }));
                const notesList = (data?.tCardCustomerNotes || []).map((note) => ({
                    ...note,
                    workflowIDs: JSON.parse(note.workflowIDs || '[]'),
                    workflow: JSON.parse(note.workflowIDs || '[]')
                        .map((id) => state.workflowsList.find((workflow) => workflow.id === id))
                        .filter(Boolean),
                    isDelete: false,
                    isUpdated: false
                }));
                setTCardCustomerNotesList(notesList);
            }
        }
    }, [state.tCardCustomerID, state.workflowsList]);

    useEffect(() => {
        fetchDropdownData();
    }, [fetchDropdownData]);

    useEffect(() => {
        fetchCustomerNotes();
    }, [fetchCustomerNotes]);

    const fieldChange = (e) => {
        let { name, value } = e.target;
        setState((st) => ({ ...st, [name]: value }));
    };

    const handleClick = (name, value) => {
        setState((st) => {
            const nst = { ...st, [name]: value };
            return nst;
        });
    };

    const handleInput = (e) => {
        const { name, value } = e.target;
        setState((st) => ({
            ...st,
            [name]: value,
            errors: { ...st.errors, [name]: '' }
        }));
    };

    const handleLineChange = (e) => {
        const { name, value } = e.target;
        setState((prev) => ({ ...prev, [name]: value }));
    };

    const handleSelectedLineStatusChange = (e, index) => {
        const { name, value, checked, type } = e.target;

        const tempList = [...tCardCustomerNotesList];
        if (type == 'checkbox') {
            tempList[index][name] = checked;
            tempList[index].isUpdated = true;
        } else {
            tempList[index][name] = value;
            tempList[index].isUpdated = true;
        }
        setTCardCustomerNotesList(tempList);
    };

    const handleDelete = (index, tCardCustomerNoteID) => {
        console.log('tCardCustomerNoteID', tCardCustomerNoteID);
        console.log('index', index);
        if (tCardCustomerNoteID) {
            let tempList = [...tCardCustomerNotesList];
            tempList[index].isDelete = true;
            tempList[index].isUpdated = true;
            setTCardCustomerNotesList(tempList);
        } else {
            let tempList = [...tCardCustomerNotesList];
            tempList.splice(index, 1);
            setTCardCustomerNotesList(tempList);
        }
    };

    const handleCheckbox = (event) => {
        const { name, checked } = event.target;
        setState((prev) => ({
            ...prev,
            [name]: checked
        }));
    };

    const handleClose = (event) => {
        resetForm();
        setState((prev) => ({
            ...prev,
            showModal: false
        }));
    };

    const handleModapOpen = (event) => {
        setState((prev) => ({
            ...prev,
            showModal: true
        }));
    };

    const handleLineSubmit = () => {
        if (validateForm()) {
            const newNote = {
                tCardCustomerNoteID: '',
                tCardCustomerNoteTypeID: state.tCardCustomerNoteTypeID,
                tCardCustomerNoteDescription: state.tCardCustomerNoteDescription,
                tCardCustomerNoteDisplayPopInInternal: state.tCardCustomerNoteDisplayPopInInternal,
                tCardCustomerNoteDisplayPopInTechnician: state.tCardCustomerNoteDisplayPopInTechnician,
                workflowIDs: state.workflowIDs,
                workflow: selectedData.workflow,
                isDelete: false,
                isUpdated: true,
                dateCreated: new Date()
            };
            setTCardCustomerNotesList((prev) => [...prev, newNote]);
            setState((prev) => ({
                ...prev,
                showModal: false
            }));
            resetForm();
        }
    };

    const UpdateLineSubmit = () => {
        if (validateForm()) {
            console.log(selectedIndex, 'selectedIndex');
            const newNote = {
                tCardCustomerNoteID: state.tCardCustomerNoteID,
                tCardCustomerNoteTypeID: state.tCardCustomerNoteTypeID,
                tCardCustomerNoteDescription: state.tCardCustomerNoteDescription,
                tCardCustomerNoteDisplayPopInInternal: state.tCardCustomerNoteDisplayPopInInternal,
                tCardCustomerNoteDisplayPopInTechnician: state.tCardCustomerNoteDisplayPopInTechnician,
                workflowIDs: state.workflowIDs,
                workflow: selectedData.workflow,
                isDelete: false,
                isUpdated: true,
                dateCreated: new Date()
            };
            let tempList = [...tCardCustomerNotesList];
            tempList[selectedIndex] = newNote;

            setTCardCustomerNotesList(tempList);

            setState((prev) => ({
                ...prev,
                showModal: false
            }));

            resetForm();
        }
    };

    const validateForm = () => {
        const errors = {};
        let isValid = true;

        if (!state.tCardCustomerNoteDescription) {
            errors.tCardCustomerNoteDescription = 'Description is required';
            isValid = false;
        }
        if (!state.tCardCustomerNoteTypeID) {
            errors.tCardCustomerNoteTypeID = 'Type is required';
            isValid = false;
        }
        if (selectedData.workflow.length === 0) {
            errors.workflow = 'Workflow is required';
            isValid = false;
        }

        setState((prev) => ({ ...prev, errors }));
        return isValid;
    };

    const resetForm = () => {
        setState((prev) => ({
            ...prev,
            tCardCustomerNoteDescription: '',
            tCardCustomerNoteTypeID: '',
            tCardCustomerNoteDisplayPopInInternal: false,
            tCardCustomerNoteDisplayPopInTechnician: false,
            workflowIDs: []
        }));
        setSelectedData({ workflow: [] });
        setSelectedIndex(null);
    };

    const handleSubmit = async () => {
        const data = {
            tCardCustomerID: state.tCardCustomerID,
            orderNumberRequired: state.orderNumberRequired,
            tCardCustomerStartupOrderPhone: state.tCardCustomerStartupOrderPhone,
            tCardCustomerStartupOrderEmail: state.tCardCustomerStartupOrderEmail,
            tCardCustomerSpendLimit: state.tCardCustomerSpendLimit,
            tCardCustomerAuthorityContactPhone: state.tCardCustomerAuthorityContactPhone,
            tCardCustomerAuthorityContactEmail: state.tCardCustomerAuthorityContactEmail,
            tCardCustomerTyreCompany: state.tCardCustomerTyreCompany,
            tCardCustomerTyreCompanyContactPhone: state.tCardCustomerTyreCompanyContactPhone,
            tCardCustomerCourtesyCarForInspection: state.tCardCustomerCourtesyCarForInspection,
            tCardCustomerFinalOrderContactPhone: state.tCardCustomerFinalOrderContactPhone,
            tCardCustomerFinalOrderContactEmail: state.tCardCustomerFinalOrderContactEmail,
            tCardCustomerAuthorityProcess: state.tCardCustomerAuthorityProcess,
            tCardCustomerRetailDefectProcess: state.tCardCustomerRetailDefectProcess,
            tCardCustomerOutOfTyreProcess: state.tCardCustomerOutOfTyreProcess,
            tCardCustomerBrakeTestPolicy: state.tCardCustomerBrakeTestPolicy,
            tCardCustomerPreferredPartsSupply: state.tCardCustomerPreferredPartsSupply,
            tCardCustomerFinalOrderNumberProcess: state.tCardCustomerFinalOrderNumberProcess,
            tCardCustomerOvernightVORUpdate: state.tCardCustomerOvernightVORUpdate,
            tCardCustomerPortalInfo: state.tCardCustomerPortalInfo,
            tCardCustomerAdditionalInfo: state.tCardCustomerAdditionalInfo,
            tCardCustomerNotes: tCardCustomerNotesList.filter((note) => note.isUpdated)
        };
        try {
            const res = await postTcardAddUpdateCustomerNotes(data);
            if (res.success) {
                showToast(res.data.message);
                onClose(true);
            } else if (res.errors) {
                for (const [key, value] of Object.entries(res?.errors)) {
                    showToast(`${key}: ${value}`);
                }
            } else {
                showToast(res.message);
                console.error(res.message);
            }
        } catch (error) {
            console.error('Error submitting data:', error);
        }
    };

    const AutoOcrDocuments = (event, value) => {
        setSelectedData((st) => ({
            ...st,
            workflow: value
        }));
        setState((st) => {
            const nst = { ...st, workflowIDs: value.map((c) => c.id), dateCreated: new Date() };
            return nst;
        });
    };
    const AutoLineOcrDocuments = (index, name) => (event, value) => {
        let tempList = [...tCardCustomerNotesList];
        tempList[index][name] = value;
        // tempList[index].dateCreated = new Date();
        tempList[index].isUpdated = true;
        tempList[index][`${name}IDs`] = value.map((c) => c.id);
        setTCardCustomerNotesList(tempList);
    };

    const downloadExcel = async () => {
        let res = await getTCardCustomersGetExcelFile(state.tCardCustomerID);
    };

    const [uploading, setUploading] = useState(false);

    const uploadDoc = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const formData = new FormData();
        formData.append(file.name, file);

        try {
            setUploading(true);
            const res = await uploadUploadCustomerDetails(state.tCardCustomerID, formData);

            if (res.success && res.data?.res?.[0]?.success === 1) {
                showToast(res.data?.res?.[0]?.msg || 'File uploaded successfully.');
                fetchCustomerNotes();
            } else {
                const errorMsg = res.data?.res?.[0]?.msg || 'Upload failed. Please try again.';
                showToast(errorMsg, 'error');
            }
        } catch (error) {
            console.error('Upload error:', error);
            showToast('An unexpected error occurred.', 'error');
        } finally {
            setUploading(false);
        }
    };

    const renderTitle = useMemo(
        () => (
            <Grid container spacing={1}>
                <Grid item xs={12} sm={6} md={6}>
                    <Grid container justifyContent="flex-start" alignItems="center">
                        <Grid item style={{ fontSize: 14 }}>
                            Customer : <span style={{ fontSize: 14, fontWeight: 'bold' }}> {selectedCustomer?.c || ''}</span>
                        </Grid>
                        {/*
                        <span >
                         */}
                        {/* <Grid> */}
                        <Tooltip title="Download Document">
                            <label>
                                <IconButton color="secondary" component="span">
                                    <CloudDownloadIcon color="secondary" onClick={downloadExcel} style={{ cursor: 'pointer' }} title="download excel" />
                                </IconButton>
                            </label>
                        </Tooltip>
                        <Tooltip title="Upload Document">
                            <label>
                                <IconButton color="secondary" component="span">
                                    <Backup />
                                    <input
                                        type="file"
                                        onChange={uploadDoc}
                                        style={{ display: 'none' }}
                                        accept=".xls,.xlsx,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                    />
                                    {uploading && <CircularProgress size={18} className="upload-progress" color="secondary" />}
                                </IconButton>
                            </label>
                        </Tooltip>
                        {/* </Grid> */}
                        {/* 
                        </span>
                        */}
                        {/* <Grid item style={{ fontSize: 14, fontWeight: 'bold' }}>
                        {selectedCustomer?.c || ''}
                        </Grid> */}
                    </Grid>
                </Grid>
            </Grid>
        ),
        [state.orderNumberRequired, selectedCustomer]
    );

    const handleCkeditorstate = (name) => (event, editor) => {
        const data = editor.getData();
        setState((st) => ({ ...st, [name]: data }));
    };

    return (
        <DialogComp overflow="auto" title={renderTitle} maxWidth="lg" fullScreen fullWidth onClose={() => onClose(false)}>
            <Grid container spacing={1}>
                <Grid container item spacing={1}>
                    <Grid item xs={12} sm={6} md={6} lg={3}>
                        <FormLabel component="legend">Spend Limit (£)</FormLabel>
                        <TextBox name="tCardCustomerSpendLimit" type="number" onChange={fieldChange} value={state.tCardCustomerSpendLimit} />
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={4}>
                        <Grid xs={12} container>
                            <Grid item sm xs={12} style={{ marginBottom: '0px' }}>
                                Order Number Mandatory
                            </Grid>

                            <YesNoButton
                                style={{ marginBottom: '5px' }}
                                state={state.orderNumberRequired}
                                name="orderNumberRequired"
                                onYesClick={() => handleClick('orderNumberRequired', true)}
                                onNoClick={() => handleClick('orderNumberRequired', false)}
                            />
                        </Grid>
                        {/* <FormControlLabel
                            control={<SecondaryCheckbox checked={state.orderNumberRequired} onChange={handleCheckbox} name="orderNumberRequired" />}
                            label="Order Number Mandatory"
                        /> */}
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={4}>
                        <Grid xs={12} container>
                            <Grid item sm xs={12} style={{ marginBottom: '0px' }}>
                                Courtesy Car for Inspection
                            </Grid>

                            <YesNoButton
                                style={{ marginBottom: '5px' }}
                                state={state.tCardCustomerCourtesyCarForInspection}
                                name="tCardCustomerCourtesyCarForInspection"
                                onYesClick={() => handleClick('tCardCustomerCourtesyCarForInspection', true)}
                                onNoClick={() => handleClick('tCardCustomerCourtesyCarForInspection', false)}
                            />
                        </Grid>
                    </Grid>

                    <Grid item xs={12} sm={6} md={6} lg={3}>
                        <FormLabel component="legend">Start-up Order Phone</FormLabel>
                        <TextBox name="tCardCustomerStartupOrderPhone" value={state.tCardCustomerStartupOrderPhone} autofocus onChange={fieldChange} />
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={3}>
                        <FormLabel component="legend">Email</FormLabel>
                        <TextBox name="tCardCustomerStartupOrderEmail" onChange={fieldChange} value={state.tCardCustomerStartupOrderEmail} />
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={3}>
                        <FormLabel component="legend">Final Order Contact Phone</FormLabel>
                        <TextBox name="tCardCustomerFinalOrderContactPhone" onChange={fieldChange} value={state.tCardCustomerFinalOrderContactPhone} />
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={3}>
                        <FormLabel component="legend">Email</FormLabel>
                        <TextBox name="tCardCustomerFinalOrderContactEmail" onChange={fieldChange} value={state.tCardCustomerFinalOrderContactEmail} />
                    </Grid>

                    <Grid item xs={12} sm={6} md={6} lg={3}>
                        <FormLabel component="legend">Authority Contact Phone</FormLabel>
                        <TextBox name="tCardCustomerAuthorityContactPhone" onChange={fieldChange} value={state.tCardCustomerAuthorityContactPhone} />
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={3}>
                        <FormLabel component="legend">Authority Contact Email</FormLabel>
                        <TextBox name="tCardCustomerAuthorityContactEmail" onChange={fieldChange} value={state.tCardCustomerAuthorityContactEmail} />
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={3}>
                        <FormLabel component="legend">Tyre Company</FormLabel>
                        <TextBox name="tCardCustomerTyreCompany" onChange={fieldChange} value={state.tCardCustomerTyreCompany} />
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={3}>
                        <FormLabel component="legend">Tyre Contact Phone</FormLabel>
                        <TextBox name="tCardCustomerTyreCompanyContactPhone" onChange={fieldChange} value={state.tCardCustomerTyreCompanyContactPhone} />
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                        <FormLabel component="legend">Customer Authority Process</FormLabel>
                        <TextBox name="tCardCustomerAuthorityProcess" value={state.tCardCustomerAuthorityProcess} multiline rows={2} onChange={fieldChange} />
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                        <FormLabel component="legend">Final Order Number Process</FormLabel>
                        <TextBox
                            name="tCardCustomerFinalOrderNumberProcess"
                            value={state.tCardCustomerFinalOrderNumberProcess}
                            multiline
                            rows={2}
                            onChange={fieldChange}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6} md={6} lg={6}>
                        <FormLabel component="legend">Out of Hours Tyre Process</FormLabel>
                        <TextBox name="tCardCustomerOutOfTyreProcess" value={state.tCardCustomerOutOfTyreProcess} onChange={fieldChange} multiline rows={2} />
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                        <FormLabel component="legend">Retail Defect Process</FormLabel>
                        <TextBox
                            name="tCardCustomerRetailDefectProcess"
                            value={state.tCardCustomerRetailDefectProcess}
                            onChange={fieldChange}
                            multiline
                            rows={2}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={4}>
                        <FormLabel component="legend">Brake Test Policy</FormLabel>
                        <TextBox name="tCardCustomerBrakeTestPolicy" value={state.tCardCustomerBrakeTestPolicy} onChange={fieldChange} />
                    </Grid>

                    <Grid item xs={12} sm={6} md={6} lg={4}>
                        <FormLabel component="legend">Overnight VOR Update</FormLabel>
                        <TextBox name="tCardCustomerOvernightVORUpdate" value={state.tCardCustomerOvernightVORUpdate} onChange={fieldChange} />
                    </Grid>
                    <Grid item xs={4}>
                        <FormLabel component="legend">Preferred Parts Supply</FormLabel>
                        <TextBox name="tCardCustomerPreferredPartsSupply" value={state.tCardCustomerPreferredPartsSupply} onChange={fieldChange} />
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                        <FormLabel component="legend">Customer Portal Info</FormLabel>
                        <TextBox name="tCardCustomerPortalInfo" value={state.tCardCustomerPortalInfo} onChange={fieldChange} multiline rows={2} />
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                        <FormLabel component="legend">Additional Info</FormLabel>
                        <TextBox name="tCardCustomerAdditionalInfo" value={state.tCardCustomerAdditionalInfo} onChange={fieldChange} multiline rows={2} />
                    </Grid>
                </Grid>
                <Grid container item spacing={1}>
                    <Grid item xs={12}>
                        <TableContainer style={{ maxHeight: 250, height: 180, border: '1px solid rgba(0,0,0,0.2)' }}>
                            <Table size="small" stickyHeader style={{ minWidth: 850 }}>
                                <TableHead>
                                    <TableRow className="header" stickyHeader>
                                        <StyledSubTableCell width="8%">
                                            <Grid container justifyContent="space-between" alignItems="center" title="Add Notes">
                                                <AddBoxIcon fontSize="medium" onClick={handleModapOpen} color="primary" style={{ cursor: 'pointer' }} />
                                            </Grid>
                                        </StyledSubTableCell>
                                        <StyledSubTableCell width="46%">Description</StyledSubTableCell>
                                        <StyledSubTableCell width="15%">Type</StyledSubTableCell>
                                        <StyledSubTableCell width="15%">Workflow</StyledSubTableCell>
                                        <StyledSubTableCell width="8%">Display Internal</StyledSubTableCell>
                                        <StyledSubTableCell width="8%">Display Technician</StyledSubTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {tCardCustomerNotesList.length > 0 &&
                                        tCardCustomerNotesList
                                            // .filter((q) => !q.isDelete)
                                            .map((q, i) => {
                                                if (!q.isDelete) {
                                                    return (
                                                        <StyledTableRow key={i}>
                                                            <StyledSubTableCell style={{ borderBottom: '1px solid rgba(0,0,0,0.3)' }}>
                                                                <RemoveCircleIcon
                                                                    onClick={() => handleDelete(i, q.tCardCustomerNoteID)}
                                                                    fontSize="small"
                                                                    style={{ color: 'red', cursor: 'pointer' }}
                                                                />
                                                                &nbsp; &nbsp;
                                                                <EditIcon
                                                                    onClick={() => editRowSelect(i)}
                                                                    fontSize="small"
                                                                    style={{ cursor: 'pointer', color: '#2964D9' }}
                                                                />
                                                            </StyledSubTableCell>
                                                            <StyledSubTableCell>
                                                                <div dangerouslySetInnerHTML={{ __html: q.tCardCustomerNoteDescription }} />
                                                            </StyledSubTableCell>
                                                            <StyledSubTableCell>
                                                                <div>{state.noteTypeList.find((k) => k.id === q.tCardCustomerNoteTypeID)?.name || '-'}</div>
                                                            </StyledSubTableCell>
                                                            <StyledSubTableCell>
                                                                <div>{q.workflow?.map((k) => k.name).join(', ') || '-'}</div>
                                                            </StyledSubTableCell>
                                                            <StyledSubTableCell>
                                                                <div>
                                                                    <SecondaryCheckbox
                                                                        checked={q.tCardCustomerNoteDisplayPopInInternal}
                                                                        onChange={(e) => handleSelectedLineStatusChange(e, i)}
                                                                        name="tCardCustomerNoteDisplayPopInInternal"
                                                                        style={{ alignItems: 'center' }}
                                                                        disabled
                                                                    />
                                                                </div>
                                                                {/* )} */}
                                                            </StyledSubTableCell>
                                                            <StyledSubTableCell>
                                                                <div>
                                                                    {' '}
                                                                    <SecondaryCheckbox
                                                                        checked={q.tCardCustomerNoteDisplayPopInTechnician}
                                                                        onChange={(e) => handleSelectedLineStatusChange(e, i)}
                                                                        name="tCardCustomerNoteDisplayPopInTechnician"
                                                                        style={{ alignItems: 'center' }}
                                                                        disabled
                                                                    />
                                                                </div>
                                                                {/* )} */}
                                                            </StyledSubTableCell>
                                                        </StyledTableRow>
                                                    );
                                                }
                                            })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>

                    <Grid item xs={6}>
                        <SecondaryButton fullWidth onClick={handleSubmit}>
                            Submit
                        </SecondaryButton>
                    </Grid>
                    <Grid item xs={6}>
                        <SecondaryButton fullWidth onClick={() => onClose(false)}>
                            cancel
                        </SecondaryButton>
                    </Grid>
                </Grid>
            </Grid>

            {state.showModal ? (
                <DialogComp overflow="auto" title={'Add Notes'} onClose={() => handleClose(false)} maxWidth="lg" fullWidth={true}>
                    <AddEditCustomerNote
                        handleCkeditorstate={handleCkeditorstate}
                        handleLineChange={handleLineChange}
                        AutoOcrDocuments={AutoOcrDocuments}
                        handleCheckbox={handleCheckbox}
                        handleLineSubmit={handleLineSubmit}
                        state={state}
                        selectedData={selectedData}
                        selectedIndex={selectedIndex}
                        UpdateLineSubmit={UpdateLineSubmit}
                    />
                </DialogComp>
            ) : null}
        </DialogComp>
    );
};
export default CustomerNotesModal;
